import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/sellers',
  title: 'Vendedores',
  endpoint: '/app/person',
  breadcrumbs: [],
}
